import { FlatList } from 'react-native';
import styled from 'styled-components/native';

import { idKeyExtractor, padding } from '@src/configuration/constants';
import { Business, Hashtag, User } from '@src/types';

export const HashTagsList = styled(
  FlatList as new () => FlatList<Hashtag>
).attrs(() => ({
  removeClippedSubviews: true,
  initialNumToRender: 20,
  maxToRenderPerBatch: 10,
  scrollEventThrottle: 16,
  keyExtractor: (item: Hashtag) => item.name,
  contentContainerStyle: {
    paddingBottom: padding,
  },
}))``;

export const BusinessList = styled(
  FlatList as new () => FlatList<Business>
).attrs(() => ({
  removeClippedSubviews: true,
  initialNumToRender: 20,
  maxToRenderPerBatch: 10,
  scrollEventThrottle: 16,
  keyExtractor: idKeyExtractor,
  contentContainerStyle: {
    paddingBottom: padding,
  },
}))``;

export const PeopleList = styled(FlatList as new () => FlatList<User>).attrs(
  () => ({
    removeClippedSubviews: true,
    initialNumToRender: 20,
    maxToRenderPerBatch: 10,
    scrollEventThrottle: 16,
    keyExtractor: idKeyExtractor,
    contentContainerStyle: {
      paddingBottom: padding,
    },
  })
)``;
